Ext.define('SA.HistogramToolbar', {
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-toolbar',

    items: [
        {
            xtype: 'combo-button',
            itemId: 'attributeDropdown',
            textField: 'text',
            ui: 'underline',
            valueField: 'value'
        }, {
            xtype: 'pvt-text',
            margin: '0 0 0 20',
            text: 'Bars are counts of'
        }, {
            xtype: 'combo-button',
            emptyText: 'N/A',
            itemId: 'unitDropdown',
            textField: 'name',
            ui: 'underline',
            valueField: 'id'
        }, {
            xtype: 'pvt-text',
            text: 'in'
        }, {
            xtype: 'pvt-location-dropdown',
            itemId: 'locationDropdown'
        }, {
            xtype: 'pvt-fill'
        }, {
            xtype: 'view-actions-menu-button-2',

            menuItems: [
                {
                    text: 'Edit View',
                    eventId: 'edit'
                }, {
                    xtype: 'menuseparator'
                }, {
                    text: 'Create Data Table',
                    eventId: 'createDataTable'
                }, {
                    xtype: 'menuseparator'
                }, {
                    text: 'Delete View',
                    eventId: 'delete'
                }
            ]
        }, {
            xtype: 'pvt-export-button',
            margin: '0 10 0 0'
        }
    ],

    initComponent() {
        this.callParent();

        this.attributeDropdown = this.down('#attributeDropdown');
        this.unitDropdown = this.down('#unitDropdown');
        this.locationDropdown = this.down('#locationDropdown');
        this.viewActionsMenuBtn = this.down('view-actions-menu-button-2');
        this.exportBtn = this.down('pvt-export-button');
    },

    initEvents() {
        this.callParent();

        this.attributeDropdown.on('afterchange', value => this.fireEvent('change:attribute', value));
        this.unitDropdown.on('afterchange', value => this.fireEvent('change:unit', value));
        this.locationDropdown.on('afterchange', value => this.fireEvent('change:location', value));
        this.viewActionsMenuBtn.on('click:menuItem:edit', () => this.fireEvent('click:viewActions:edit'));
        this.viewActionsMenuBtn.on('click:menuItem:createDataTable', () => this.fireEvent('click:viewActions:createDataTable'));
        this.viewActionsMenuBtn.on('click:menuItem:delete', () => this.fireEvent('click:viewActions:delete'));
        this.exportBtn.on('activate', this.onActivateExportBtn, this);
    },

    onActivateExportBtn() {
        this.fireEvent('activate:exportBtn', this.exportBtn);
    },

    setAttributeDropdownState({selected, supported}) {
        var items = supported.ids.map(value => ({value, text: SA.data.AttributesCache.getLabel(value)}));

        this.attributeDropdown.setItemsAndValue(items, selected.id, {suppressEvent: true});
    },

    setLocationDropdownState({selected, supported}) {
        var getLocation = location => SA.data.LocationsCache.get(location),
            items = supported.ids.map(getLocation),
            selected = getLocation(selected.id);

        this.locationDropdown.setItemsAndValue(items, selected, {suppressEvent: true});
    },

    setState(modelState) {
        this.setAttributeDropdownState(modelState.attributes);
        this.setLocationDropdownState(modelState.locations);
        this.setUnitDropdownState(modelState.geoUnits);
    },

    setUnitDropdownState({selected, supportedDiscoverable}) {
        var units = [selected, ...supportedDiscoverable],
            items = SA.data.GeographicUnits.get(units).map(({id, name}) => ({id, name}));

        this.unitDropdown.setEnabled(items.length);
        this.unitDropdown.setItemsAndValue(items, selected, {suppressEvent: true});
    }
});